import React from "react";
import {
  Alert,
  Keyboard,
  SafeAreaView,
  StatusBar,
  TouchableOpacity,
} from "react-native";
import { useEffect, useState } from "react";
import GlobalStyles from "./GlobalStyles";
import Home from "./components/LoanApplication/Home";
import Login from "./components/SignIn/Login";
import LoginWeb from "./components/SignIn/LoginWeb";
import Signup from "./components/SignUp/Signup";
import SignupWeb from "./components/SignUp/SignupWeb";
import { NavigationContainer } from "@react-navigation/native";
import DashBoard from "./components/DashBoard/DashBoard";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { context } from "./components/accessories/accessories";
import ShareApp from "./components/NavigationBar/ShareApp";
import {
  checkForUpdates,
  handleCheckAlreadyLogIn,
  queryStringToObject,
  updateWebURL,
  getQueryString,
} from "./components/accessories/CommonFunctions";

import { web } from "./components/accessories/Platform.js";
import ExternalSourceViewer from "./components/accessories/ExternalSourceViewer";
import DocumentViewer from "./components/LoanApplication/DocumentUpload/DocumentViewer";
import * as Font from "expo-font";
import {
  setJSExceptionHandler,
  setNativeExceptionHandler,
} from "react-native-exception-handler";
import Plaid from "./components/Plaid/Plaid";
import StartScreen from "./components/LoanApplication/StartScreen/StartScreen";
import { LinearGradient } from "expo-linear-gradient";
import Calculator from "./components/NavigationBar/Calculator";
import * as SplashScreen from "expo-splash-screen";
import LoanContacts from "./components/NavigationBar/LoanContacts";
import Settings from "./components/NavigationBar/Setting";
import EvilIcons from "react-native-vector-icons/EvilIcons";
import CalculatorMenu from "./components/accessories/CalculatorMenu";
import useKeyboardHeight from "./components/accessories/KeyboardHeight";
import Payment from "./components/Payment/Payment.js";

const errorHandler = (e, isFatal) => {
  if (isFatal) {
    Alert.alert(
      "Unexpected error occurred",
      `
        Error: ${e.name} - ${e.message}
        `,
      [
        {
          text: "Ok",
          onPress: () => {
            // RNRestart.Restart();
          },
        },
      ]
    );
  } else {
    console.log(e);
  }
};

if (!web && !__DEV__) {
  setJSExceptionHandler(errorHandler, false);

  setNativeExceptionHandler((errorString) => {
    Alert.alert(
      "Unexpected native error occurred",
      `
      Error: ${errorString}
      `,
      [
        {
          text: "Ok",
          onPress: () => {
            // RNRestart.Restart();
          },
        },
      ]
    );
  });
}

const Stack = createNativeStackNavigator();
SplashScreen.preventAutoHideAsync();

// setTimeout(() => SplashScreen.hideAsync(), 2000);

export default function App(props) {
  const [contextDetails, setContextDetails] = useState({
    Path: web ? "Login" : "StartScreen",
    appDownloadFlag: false,
    loanProductStatus: null,
  });
  const [title, setTitle] = useState("Login");
  const [fontsLoaded, setFontsLoaded] = useState(false);

  const loadFont = async () => {
    await Font.loadAsync({
      OpenSansRegular: require("./assets/fonts/OpenSansRegular.ttf"),
      OpenSansBold: require("./assets/fonts/OpenSansBold.ttf"),
      OpenSansItalic: require("./assets/fonts/OpenSans-Italic.ttf"),
      OpenBoldItalic: require("./assets/fonts/OpenSans-BoldItalic.ttf"),
      PlayFair: require("./assets/fonts/Playfair_9pt_SemiCondensed-Regular.ttf"),
      Regular: require("./assets/fonts/Helvetica-Regular.otf"),
      RobotoRegular: require("./assets/fonts/Roboto-Regular.ttf"),
      RobotoMedium: require("./assets/fonts/Roboto-Medium.ttf"),
      Inter: require("./assets/fonts/Inter.ttf"),
      segoeUI: require("./assets/fonts/segoe-ui.ttf"),
      segoeUIBold: require("./assets/fonts/segoe-ui-bold.ttf"),
      segoeUIBold700: require("./assets/fonts/SegoeUIBold.ttf"),
    });

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
    } catch (e) {
      console.error(e);
    } finally {
      setFontsLoaded(true);
      SplashScreen.hideAsync();
    }
  };

  const keyboardHeight = useKeyboardHeight() || null;

  useEffect(() => {
    checkForUpdates(true);
    const prePare = async () => {
      if (web) {
        let obj = queryStringToObject(window.location?.href || ""),
          iTitle = obj["Path"] || "Login";

        // Add loan officer and partner ID extraction
        const loanOfficerId = obj["loanofficer"] || obj["loanOfficerId"] || 0;
        const partnerId = obj["PartnerId"] || 0;

        obj = {
          ...obj,
          loanId: obj["loanId"] || obj["loanid"],
          loanOfficerId: loanOfficerId, // Add this
          PartnerId: partnerId, // Add this
        };

        // obj = { ...obj, loanId: obj["loanId"] || obj["loanid"] };
        if (obj["Path"] === "Signup") obj["Path"] = "Login";
        else if (obj["Path"] === "Login") {
          iTitle = "Log In";
          updateWebURL();
        } else if (obj["Path"] === "Signup") iTitle = "Sign Up";
        else if (obj["Path"] === "DashBoard" || "Home" === obj["Path"]) {
          iTitle = "Borrower Welcome";
        } else if (
          obj["Path"] === "DocumentViewer" ||
          "DocumentViewer" === obj["Path"]
        ) {
          iTitle = "Document Viewer";
        }

        obj && setContextDetails({ ...contextDetails, ...obj });
        setTitle(iTitle);
        setFontsLoaded(true);
        document.getElementById("root").style.minWidth = "350px";
      } else {
        let logInDetails = (await handleCheckAlreadyLogIn()) || {};

        let { SessionId, UserDisplayName } = logInDetails;
        SessionId &&
          setContextDetails({
            ...contextDetails,
            ...{ Path: "DashBoard", SessionId },
          });
        loadFont();
      }
    };
    prePare();
  }, [props]);

  if (!fontsLoaded) {
    return null;
  }

  return (
    <context.Provider value={{ contextDetails, setContextDetails }}>
      <NavigationContainer>
        <LinearGradient
          colors={
            contextDetails["Path"] === "StartScreen"
              ? ["#66BBE9", "#66BBE9", "#204C86"]
              : ["#fff", "#fff", "#f0f0f0"]
          }
          style={{
            flex: 1,
          }}
        >
          <SafeAreaView style={[GlobalStyles.droidSafeArea]}>
            <StatusBar
              animated={true}
              backgroundColor={
                contextDetails["Path"] === "StartScreen" ? "#66BBE9" : "#fff"
              }
              barStyle="dark-content"
              showHideTransition="slide"
            />

            <Stack.Navigator
              initialRouteName={contextDetails["Path"]}
              screenOptions={{
                title: title,
                headerShown: false,
              }}
            >
              <Stack.Screen name="StartScreen" component={StartScreen} />
              <Stack.Screen name="Login" component={web ? LoginWeb : Login} />
              <Stack.Screen
                name="Signup"
                component={web ? SignupWeb : Signup}
              />
              <Stack.Screen name="DashBoard" component={DashBoard} />
              <Stack.Screen name="Home" component={Home} />
              <Stack.Screen name="Pdf" component={ExternalSourceViewer} />
              <Stack.Screen name="DocumentViewer" component={DocumentViewer} />
              <Stack.Screen name="Plaid" component={Plaid} />
              <Stack.Screen name="ShareApp" component={ShareApp} />
              <Stack.Screen name="Calculator" component={Calculator} />
              <Stack.Screen name="Payment" component={Payment} />
              <Stack.Screen name="CalculatorMenu" component={CalculatorMenu} />
              <Stack.Screen name="LoanContacts" component={LoanContacts} />
              <Stack.Screen name="Settings" component={Settings} />
            </Stack.Navigator>
          </SafeAreaView>
        </LinearGradient>
      </NavigationContainer>
      {keyboardHeight && (
        <TouchableOpacity
          onPress={() => {
            Keyboard.dismiss();
          }}
          style={{
            backgroundColor: "#fff",
            borderRadius: 50,
            borderWidth: 1,
            position: "absolute",
            bottom: keyboardHeight,
            right: 3,
            width: 26,
            height: 25,
            justifyContent: "center",
          }}
        >
          <EvilIcons name="chevron-down" size={25} />
        </TouchableOpacity>
      )}
    </context.Provider>
  );
}
